import {
  Component,
  Inject,
  Injector,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';
import { ProductService } from '@product/shared/services/product.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-bulk-edit-field',
  templateUrl: './bulk-edit-field.component.html',
  styleUrls: ['./bulk-edit-field.component.less'],
})
export class BulkEditFieldComponent extends BaseComponent implements OnInit {
  @Input() field: ModelField;
  @Input() dropDownsMetaData: { [key: string]: DropDownOption[] } = {};
  @Input() formGroup: FormGroup;
  @Input() isBulkEdit: boolean;
  @Input() objectTypeId: number;
  @Input() record: any;
  injector: Injector;
  constructor(injector: Injector) {
    super(injector);
    this.injector = injector;
  }

  ngOnInit() {
    this.isLoading = false;
  }

  changeCheckbox(status: any) {
    this.isLoading = true;
    if (status) {
      if (
        [6, 7].includes(this.field.DataType) &&
        !isNaN(+this.field.Code) &&
        this.dropDownsMetaData[this.field.Code] == null
      ) {
        const code = this.field.Code.toString().includes('.')
          ? this.field.Code.toString().split('.')[1]
          : this.field.Code.toString();
        this.attributesService
          .getAttributeOptions([code])
          .subscribe((options: any) => {
            Object.keys(options).forEach((key) => {
              const opts = options[key] as any[];
              this.dropDownsMetaData[key] = [
                ...opts.map((opt) => {
                  const metaOpt: DropDownOption = {
                    Code: opt.id,
                    Label: opt.name,
                  };
                  return metaOpt;
                }),
              ];
            });
            this.isLoading = false;
          });
      } else if (
        this.field.Code === 'InheriteFrom' &&
        (this.dropDownsMetaData[this.field.Code] == null ||
          this.dropDownsMetaData[this.field.Code]?.length === 0)
      ) {
        const productService = this.injector.get(ProductService);
        this.subscriptions.push(
          productService
            .getProductsToInherit(0, {
              Filters: {},
              IsAscend: false,
              PageIndex: 0,
              PageSize: 100000,
              SortBy: 'Id',
            })
            .pipe(
              tap((response) => {
                this.dropDownsMetaData[this.field.Code] = response.map(
                  (prod) => {
                    return {
                      Code: prod.id!,
                      Label: `${prod.sku} - ${prod.name!}`,
                    };
                  }
                );
                this.isLoading = false;
              })
            )
            .subscribe()
        );
      } else {
        this.isLoading = false;
      }
      this.addControl(this.field);
    } else {
      this.formGroup.removeControl(`${this.field.DataType}.${this.field.Code}`);
      this.field.Checked = false;
    }
  }

  addControl(field: any) {
    this.formGroup.addControl(
      `${field.DataType}.${field.Code}`,
      new FormControl(null, field.IsRequired ? Validators.required : null)
    );
    if (this.isBulkEdit) {
      this.formGroup.addControl(
        `${field.DataType}.${field.Code}.from`,
        new FormControl(null)
      );
    }
    this.field.Checked = true;
  }
}
